import { render, staticRenderFns } from "./CargoDetailRow.vue?vue&type=template&id=d21e8928&"
import script from "./CargoDetailRow.vue?vue&type=script&lang=js&"
export * from "./CargoDetailRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports